import { z } from "zod";

const baseLoyaltyFields = {
  orderConfirmationLoyaltyUrl: z.string(),
  redemptionTabSymbol: z.string(),
  learnMoreUrl: z.string(),
  showReminderDialog: z.boolean(),
};

const loyaltyShowMgmFields = {
  showMgm: z.literal(true),
  reminderDialogTitle: z.string(),
  reminderDialogSubtitle: z.string(),
  reminderDialogText: z.string(),
  reminderDialogSecondaryButtonText: z.string(),
  reminderDialogSecondaryButtonLink: z.string(),
};

const loyaltyNoMgmFields = {
  showMgm: z.literal(false),
  reminderDialogTitle: z.string().optional(),
  reminderDialogSubtitle: z.string().optional(),
  reminderDialogText: z.string().optional(),
  reminderDialogSecondaryButtonText: z.string().optional(),
  reminderDialogSecondaryButtonLink: z.string().optional(),
};

export const loyaltySchema = z.discriminatedUnion("showMgm", [
  z.object({
    ...baseLoyaltyFields,
    ...loyaltyNoMgmFields,
  }),
  z.object({
    ...baseLoyaltyFields,
    ...loyaltyShowMgmFields,
  }),
]);
